export enum EventStatus {
  SCHEDULED = 'SCHEDULED',
  PRE_LIVE = 'PRE_LIVE',
  LIVE = 'LIVE',
  POST_LIVE = 'POST_LIVE',
  ON_DEMAND = 'ON_DEMAND',
  CANCELED = 'CANCELED',
}
